import api from '../utils/api';
import { logError } from '@zg-rentals/log-error';

const SchedulerActions = {
  update(listingId, schedule = {}) {
    return (dispatch) =>
      dispatch(api.users.scheduler.update(listingId, schedule))
        .then((result) => {
          const { error: errorRMWModel, success } = result;

          if (success === false) {
            return Promise.reject(errorRMWModel);
          }

          return result.response;
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'SchedulerActions.update',
          });

          return Promise.reject(errorRMWModel);
        });
  },
};

export default SchedulerActions;
